import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchPsychiatricForm } from "../../../store/slices/psychiatricFormSlice";
import PrintWrapper, { printFooterStyles } from "../../common/PrintWrapper";
import logo from "../../../assets/images/logo-samplee.png";

export default function PsychFormPrint() {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Store.js mein jis naam se reducer hai wo yahan use karein (usually 'psychiatricForms')
    const psychState = useSelector((state) => state.psychiatricForm || {});
    const { currentPsychiatricForm, isLoading, error } = psychState;

    useEffect(() => {
        if (id) dispatch(fetchPsychiatricForm(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (currentPsychiatricForm) {
            const timer = setTimeout(() => window.print(), 1000); // 1 sec delay for safety
            window.onafterprint = () => navigate(-1);
            return () => {
                clearTimeout(timer);
                window.onafterprint = null;
            };
        }
    }, [currentPsychiatricForm, navigate]);

    if (isLoading) return <div className="p-8 text-center">Loading Psychiatric Orders...</div>;
    if (error) return <div className="p-8 text-danger text-center">{error}</div>;

    // Agar record load nahi hua toh check karein
    if (!currentPsychiatricForm) return <div className="p-8 text-center">No record found.</div>;

    const d = currentPsychiatricForm;

    const fmtDate = (dateStr) =>
        dateStr ? new Date(dateStr).toLocaleDateString("en-GB", {
            day: "2-digit", month: "short", year: "numeric",
        }) : "";

    const fmtDateTime = (dtStr) =>
        dtStr ? new Date(dtStr).toLocaleString("en-GB", {
            day: "2-digit", month: "short", year: "numeric",
            hour: "2-digit", minute: "2-digit", hour12: true
        }) : "";

    return (
        <>
            <style jsx global>{`
                * { box-sizing: border-box !important; font-family: Arial, sans-serif !important; }
                body { background: #fff !important; color: #000 !important; font-size: 13px !important; margin: 0 !important; padding: 0 !important; }
                .print-container { padding: 30px !important; position: relative !important; }
                ${printFooterStyles}
                .logo { position: absolute !important; top: 15px !important; left: 20px !important; }
                .logo img { height: 65px !important; width: auto !important; }
                
                .header { text-align: center !important; margin-bottom: 25px !important; border-bottom: 2px solid #000 !important; padding-bottom: 10px !important; }
                .header h3 { font-size: 1.6rem !important; font-weight: bold !important; }
                .header h6 { font-size: 1.1rem !important; text-transform: uppercase !important; margin-top: 5px !important; }

                .patient-info-table { width: 100% !important; border-collapse: collapse !important; margin-bottom: 20px !important; }
                .patient-info-table td { border: 1px solid #000 !important; padding: 8px !important; }
                .label-bg { background: #f2f2f2 !important; font-weight: bold !important; width: 20% !important; }

                .orders-table { width: 100% !important; border-collapse: collapse !important; margin-top: 10px !important; }
                .orders-table th, .orders-table td { border: 1px solid #000 !important; padding: 12px 8px !important; vertical-align: top !important; }
                .orders-table th { background: #eee !important; font-weight: bold !important; text-align: center !important; }
                
                .row-index { width: 40px !important; text-align: center !important; }
                .row-date { width: 160px !important; text-align: center !important; }
                .row-nurse { width: 160px !important; text-align: center !important; }

                .meta-footer { width: 100% !important; border-collapse: collapse !important; margin-top: 30px !important; font-size: 11px !important; }
                .meta-footer td { border: 1px solid #000 !important; padding: 6px !important; }

                .footer-brand { margin-top: 40px !important; border-top: 1px solid #000 !important; padding-top: 10px !important; text-align: center !important; font-size: 11px !important; }
            `}</style>

            <PrintWrapper>
                <div className="print-container">
                <div className="logo"><img src={logo} alt="Logo" /></div>
                <div className="header">
                    <h3>THE RECOVERY HOUSE</h3>
                    <h6>PSYCHIATRIST ORDER SHEET</h6>
                </div>

                <table className="patient-info-table">
                    <tbody>
                        <tr>
                            <td className="label-bg">Patient Name</td>
                            <td colSpan="3">{d.name}</td>
                        </tr>
                        <tr>
                            <td className="label-bg">M.R No.</td>
                            <td>{d.mr_no}</td>
                            <td className="label-bg">Room No.</td>
                            <td>{d.room_no}</td>
                        </tr>
                        <tr>
                            <td className="label-bg">Consultant</td>
                            <td colSpan="3">{d.consultant}</td>
                        </tr>
                    </tbody>
                </table>

                <table className="orders-table">
                    <thead>
                        <tr>
                            <th className="row-index">S#</th>
                            <th className="row-date">Date & Time</th>
                            <th>Doctor's Orders / Instructions</th>
                            <th className="row-nurse">Nurse</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* Corrected mapping: using d.orders from backend response */}
                        {d.orders && d.orders.length > 0 ? (
                            d.orders.map((row, index) => (
                                <tr key={row.id || index}>
                                    <td className="row-index">{index + 1}</td>
                                    <td className="row-date">{fmtDateTime(row.date_time)}</td>
                                    <td style={{ whiteSpace: 'pre-wrap' }}>{row.order}</td>
                                    <td className="row-nurse">{row.nurse}</td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="4" className="text-center p-4">No orders found.</td></tr>
                        )}
                    </tbody>
                </table>


                <div className="footer-brand">
                    <p>156 Bangalore Town, Tipu Sultan Road Karachi-Pakistan | Ph: 021-34546364-65-66</p>
                    <p><strong>A Project of “CARVAN OF LIFE PAKISTAN TRUST”</strong></p>
                </div>
            </div>
            </PrintWrapper>
        </>
    );
}